import { ServiceOffering } from '../../api/services.types';

export type ServiceOfferingActions = SetServiceOfferingFetchingAction | SetServiceOfferingAction;

export interface SetServiceOfferingFetchingAction {
  type: 'SERVICE_OFFERING_SET_IS_FETCHING';
  data: boolean;
}
export function setServiceOfferingFetching(value: boolean): SetServiceOfferingFetchingAction {
  return {
    type: 'SERVICE_OFFERING_SET_IS_FETCHING',
    data: value,
  };
}

export interface SetServiceOfferingAction {
  type: 'SERVICE_OFFERING_SET_SERVICE_OFFERING';
  data: ServiceOffering[];
}
export function setServiceOffering(value: ServiceOffering[]): SetServiceOfferingAction {
  return {
    type: 'SERVICE_OFFERING_SET_SERVICE_OFFERING',
    data: value,
  };
}
